import { render, staticRenderFns } from "./SystemInformationBin.vue?vue&type=template&id=512a1082&scoped=true"
import script from "./SystemInformationBin.vue?vue&type=script&lang=ts"
export * from "./SystemInformationBin.vue?vue&type=script&lang=ts"
import style0 from "./SystemInformationBin.vue?vue&type=style&index=0&id=512a1082&prod&lang=css"
import style1 from "./SystemInformationBin.vue?vue&type=style&index=1&id=512a1082&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512a1082",
  null
  
)

export default component.exports